// src/i18n/payout.ts —— 06 admin-console C-16 / C-17 / C-18 文案包（代付 / 收单订单与物流 / 上游；经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06（含 Toast 映射表）；06 未给英文或未给键名的标「本计划定稿」（W-7 回写）。
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_PAYOUT: I18nPack = {
  zh: {
    // C-16 代付管理
    quotaLimit: '合计', // [改写 key]
    quotaUsed: '冻结（在途）', // [改写 key]
    quotaLeft: '可用', // [改写 key]
    cRemark: '备注',
    stSubmitted: '已提交',
    cReconcile: '对账',
    stRecScheduled: '对账排队',
    stRecManual: '待人工确认',
    cCountry: 'Country', // 本计划定稿（与原型列字面一致）
    recTitle: '人工确认终态 · {biz_no}',
    recTip: '请先在上游商户后台核实该代付单的真实结果，确认后本地终态不可再变更。',
    recOutcome: '终态结果',
    recNote: '核实说明',
    toastPayoutReconciled: '已人工确认代付终态',
    // C-17 收单订单与物流
    stAwaitShip: '待发货',
    cancelTrackTitle: '取消物流单',
    cancelTrackText: '将调用上游删除该运单，订单回到待发货，可重新标记发货。',
    toastLogisticsCancel: '物流单已取消',
    aCancelTrack: '取消',
    cCarrierOther: '承运商名称',
    // C-18 上游 API / 商户钱包
    toastRotate: '密钥轮换需通过部署流程执行，后台不提供在线轮换', // [改写 key] 06 Toast 映射
    toastTest: '测试回调已发送 · {http_status}', // [改写为模板] 06 Toast 映射
    // 本波自造键（W-7 回写）
    payBenMore: '更多请到收款账户页筛选', // 计划 §6-P9
    payRetryTitle: '重试代付',
    payRetryText: '将以新的商户单号向上游重新发起该笔代付，原单保持失败。',
    payAReconcile: '人工确认终态',
    payFeeUpstream: '手续费（上游）',
    payCMethod: '方式',
    payQuotaStale: '同步失败，显示为上次成功值', // 06 C-16 Tab2 状态列
    payRecNotePh: '上游后台核实结果与依据', // 06 C-16 payoutReconcile 表单提示文案
    payStEnable: '启用',
    payStDisable: '停用',
    payErrAmount: '金额须大于 0，最多 6 位小数',
    payErrOverQuota: '金额超出代付可用额度 {left}',
    payErrRemark: '备注不超过 255 个字符',
    payErrRecNote: '核实说明必填，不超过 255 个字符',
    payErrBenName: '收款账户名称必填，不超过 128 个字符',
    payErrCountry: 'Country 须为两位大写国家代码（如 US）',
    payErrCarrierOther: '承运商为 OTHER 时须填写承运商名称（不超过 64 个字符）',
    payErrTracking: '运单号必填，不超过 64 个字符',
    payErrRetryState: '该代付单当前状态不可重试，已刷新列表',
    payErrRefundState: '订单当前状态不可退款，已刷新列表',
    payErrShipState: '订单当前状态不可标记发货，已刷新列表',
    payErrTrackState: '物流单当前状态不可取消，已刷新列表',
  },
  en: {
    quotaLimit: 'Total',
    quotaUsed: 'Frozen (in transit)',
    quotaLeft: 'Available',
    cRemark: 'Remark',
    stSubmitted: 'Submitted',
    cReconcile: 'Reconcile',
    stRecScheduled: 'Scheduled',
    stRecManual: 'Manual review',
    cCountry: 'Country',
    recTitle: 'Confirm final outcome · {biz_no}', // 本计划定稿
    recTip: 'Verify the real result of this payout in the upstream merchant console first; the local final state cannot be changed afterwards.', // 本计划定稿
    recOutcome: 'Final outcome', // 本计划定稿
    recNote: 'Verification note', // 本计划定稿
    toastPayoutReconciled: 'Payout outcome confirmed',
    stAwaitShip: 'Awaiting shipment',
    cancelTrackTitle: 'Cancel tracking', // 本计划定稿
    cancelTrackText: 'The tracking number will be deleted upstream and the order returns to awaiting shipment; it can be marked shipped again.', // 本计划定稿
    toastLogisticsCancel: 'Tracking cancelled',
    aCancelTrack: 'Cancel', // 本计划定稿
    cCarrierOther: 'Carrier name', // 本计划定稿
    toastRotate: 'Key rotation runs via the deployment process, not the console',
    toastTest: 'Test webhook sent · {http_status}',
    payBenMore: 'More in the payee accounts tab',
    payRetryTitle: 'Retry payout',
    payRetryText: 'The payout will be re-submitted upstream under a new merchant order number; the original stays failed.',
    payAReconcile: 'Confirm outcome',
    payFeeUpstream: 'Fee (upstream)',
    payCMethod: 'Method',
    payQuotaStale: 'Sync failed, showing last successful values',
    payRecNotePh: 'Upstream console result and evidence',
    payStEnable: 'Enabled',
    payStDisable: 'Disabled',
    payErrAmount: 'Amount must be greater than 0 with at most 6 decimals',
    payErrOverQuota: 'Amount exceeds the available payout quota {left}',
    payErrRemark: 'Remark must be at most 255 characters',
    payErrRecNote: 'Verification note is required (at most 255 characters)',
    payErrBenName: 'Account name is required (at most 128 characters)',
    payErrCountry: 'Country must be a 2-letter uppercase code (e.g. US)',
    payErrCarrierOther: 'Carrier name is required when carrier is OTHER (at most 64 characters)',
    payErrTracking: 'Tracking number is required (at most 64 characters)',
    payErrRetryState: 'This payout can no longer be retried; list refreshed',
    payErrRefundState: 'This order can no longer be refunded; list refreshed',
    payErrShipState: 'This order cannot be marked shipped now; list refreshed',
    payErrTrackState: 'This tracking can no longer be cancelled; list refreshed',
  },
};

// TD-805：覆盖原型字典的键（06 [改写 key]）
export const REWRITES_PAYOUT: readonly string[] = ['quotaLimit', 'quotaUsed', 'quotaLeft', 'toastRotate', 'toastTest'];
